export type {
  EvaluationContext,
  FeatureFlagAdapter,
  FlagEvaluation,
} from './adapter.types';

export { createDefaultAdapter } from './create-adapter';
export { FliptAdapter } from './flipt.adapter';
export {
  StaticFeatureFlagAdapter,
  E2E_FEATURE_FLAGS_WINDOW_KEY,
  getE2EFeatureFlagSnapshot,
  hasE2EFeatureFlagSnapshot,
} from './static.adapter';
export type { E2EFeatureFlagSnapshot } from './static.adapter';
